import { createReducers, createActions, request } from '../../../utils/';
import { combineReducers } from 'redux';
import Urls from '../../../../config/index';
import { message } from 'antd';
import _ from 'lodash';
import moment from 'moment';
const { taskExcuteDataUrl } = Urls;

const path = name => `app/pages/monitor/taskExcuteData/${name}`;
const models = {
    list: {
        data: [],
        handlers: {
            get(state, action) {
                return action.payload;
            },
            add(state, action) {
                return [...action.payload, ...state];
            },
            del(state, action) {
                return state.filter(item => item._id !== action.payload);
            },
            update(state, action) {
                return state.map(item => (item._id === action.payload._id ? action.payload : item));
            },
        },
    },
    taskMonitorList: {
        data: [],
        handlers: {
            setMonitorList(state, action) {
                return action.payload;
            },
        }
    },
    listEv: {
        data: [],
        handlers: {
            setlistEv(state, action) {
                return action.payload;
            },
        }
    },
    listAll: {
        data: [],
        handlers: {
            getAll(state, action) {
                return action.payload;
            },
        },
    },
    transferData: {
        data: {
            selectedRowKeys: [],
        },
        handlers: {
            getTransferData(state, action) {
                return {...state, ...action.payload};
            },
        },
    },
    pagination: {
        data: {
            current: 1,
            total: 0,
            pageSize: 10,
        },
        handlers: {
            changePagination(state, action) {
                return {
                    ...state,
                    ...action.payload,
                };
            },
        },
    },
    searchValues: {
        data: {
           // beginTime: moment().format('YYYY-MM-DD'),
            //endTime: moment().format('YYYY-MM-DD'),
        },
        handlers: {
            changeSearchValues(state, action) {
                return action.payload;
            },
        },
    },
    uiStatus: {
        data: {
            isLoading: false,
            isUpdateShow: false,
            isSendCommend: false,
            onSelectTab: 1,
        },
        handlers: {
            changeUiStatus(state, action) {
                return {
                    ...state,
                    ...action.payload,
                };
            },
        },
    },
    currentSelect: {
        data: {},
        handlers: {
            changeCurrentSelect(state, action) {
                return action.payload;
            },
        },
    },
    pricpleList: {
        data: [],
        handlers: {
            getList(state, action) {
                return action.payload;
            },
        },
    },
    currentSelectId: {
        data: '',
        handlers: {
            changeCurrentSelectId(state, action) {
                return action.payload;
            },
        },
    },
};

export const actions = createActions(models, path);

export default combineReducers(createReducers(models, path));

const formatGetParams = getState => {
    const state = getState().taskExcuteData;
    const searchValue = state.searchValues || {};

    const params = {
        ...searchValue,
        page: state.pagination.current,
        pageSize: state.pagination.pageSize,
    };
    return params;
};


/**
 * 获取检测公司列表
 */
export const asyncGetMonitorList = () => {
    return async (dispatch, getState) => {
        try {
            let result = await request(taskExcuteDataUrl.getMonitorNames, 'POST');
            dispatch(actions.setMonitorList(result));
        } catch (e) {
            throw e;
        }
    };
};

/**
 * 获取taskNOtes数据
 */
export const asyncGet = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    isLoading: true,
                }),
            );
            // 下面的请求和结果返回需要根据接口来实现
            let result = await request(taskExcuteDataUrl.getTaskExcuteDate, 'POST', formatGetParams(getState));
            result.list.map(item => {
                item.key = item.eId+"-"+item.taskType;
                item.listTasks.map(item1 => {
                    item1.key = item1.index;
                    return item1;
                })
                return item;
            });
            dispatch(actions.get(result.list));
            dispatch(actions.changePagination({totalPage: result.total}));
        } catch (e) {
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isLoading: false,
                }),
            );
        }
    };
};

export const asyncGetEvs = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    isLoading: true,
                }),
            );
            // 下面的请求和结果返回需要根据接口来实现
            let result = await request(taskExcuteDataUrl.getTaskExcuteEvDate, 'POST', formatGetParams(getState));
            result.list.map(item => {
                item.key = item.index;
                return item;
            });
            dispatch(actions.setlistEv(result.list));
            dispatch(actions.changePagination({totalPage: result.total}));
        } catch (e) {
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isLoading: false,
                }),
            );
        }
    };
};

export const asyncGetTaskInfo = (record, type) => {
    return async (dispatch, getState) => {
        try {
            if (type) {
                dispatch(
                    actions.changeUiStatus({
                        isLoading: true,
                    }),
                );
                // 下面的请求和结果返回需要根据接口来实现
                let result = await request(signUrl.getEveryDayCheckInfo, 'POST', {pricple: record.pricple});
                record.taskList = result;
            }
            dispatch(actions.changeCurrentSelect({record, type}));
        } catch (e) {
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isLoading: false,
                }),
            );
        }
    };
};

/**
 * 获取订单列表数据
 */
export const asyncGetUserList = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    isLoading: true,
                }),
            );
            // 下面的请求和结果返回需要根据接口来实现
            let result = await request(signUrl.getUserList, 'GET');
            dispatch(actions.getList(result));
        } catch (e) {
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isLoading: false,
                }),
            );
        }
    };
};

export const asyncUpdate = contents => {
    return async (dispatch, getState) => {
        try {
            dispatch(actions.changeUiStatus({ isLoading: true }));
            // 下面的请求和结果返回需要根据接口来实现
            await request(taskNotesUrl.editTaskNotes, 'POST', contents);
            message.success('修改成功');
            dispatch(actions.changeUiStatus({ isUpdateShow: false }));
        } catch (e) {
            throw e;
        } finally {
            dispatch(actions.changeUiStatus({ isLoading: false }));
        }
    };
};

export const asyncAdd = contents => {
    return async (dispatch, getState) => {
        try {
            dispatch(actions.changeUiStatus({ isLoading: true }));
            // 下面的请求和结果返回需要根据接口来实现
            await request(taskNotesUrl.addTaskNotes, 'POST', contents);
            message.success('添加成功');
            dispatch(actions.changeUiStatus({ isUpdateShow: false }));
        } catch (e) {
            throw e;
        } finally {
            dispatch(actions.changeUiStatus({ isLoading: false }));
        }
    };
};

export const delect = record => {
    return async (dispatch, getState) => {
        try {
            dispatch(actions.changeUiStatus({ isLoading: true }));
            // 下面的请求和结果返回需要根据接口来实现
            await request(taskNotesUrl.delTaskNotes, 'POST', record);
            message.success('删除成功');
            dispatch(actions.changeUiStatus({ isUpdateShow: false }));
        } catch (e) {
            throw e;
        } finally {
            dispatch(actions.changeUiStatus({ isLoading: false }));
        }
    };
};






// WEBPACK FOOTER //
// ./pages/monitor/taskExcuteData/reducers.js